import * as Sentry from '@sentry/browser';
import noop from 'lodash/noop';
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { getUser } from '@zocdoc-frontend-common/state-user-account/actions/user';
import { default as BaseHeader, primitives } from './Header';

const HeaderContainer = (props) => {
    const { getUser, onGetUser = noop, theme, user } = props;

    const fetchUserData = useCallback(async () => {
        try {
            await getUser();
        } catch (e) {
            Sentry.captureException(e);
        }
    }, [getUser]);

    useEffect(() => {
        if (user) {
            onGetUser(user);
        } else if (theme.allowSignIn) {
            fetchUserData();
        }
    }, [fetchUserData, onGetUser, theme, user]);

    return <BaseHeader {...props} />;
};

// The identity function actually does something! Don't remove it.
const mapStateToProps = (state) => {
    const { user, signInForm } = state;
    return {
        user,
        signInForm,
    };
};

const mapDispatchToProps = { getUser };
const ConnectedHeader = connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderContainer);

const Header = withTheme(ConnectedHeader);

export default Header;

export { primitives, Header };
